import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";

export function IdeaTab({ profile, update }) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Your Idea</h2>
      <Card className={profile.no_idea ? "border-amber-300 bg-amber-50/50" : ""}>
        <CardContent className="p-4">
          <div className="flex items-center gap-3 mb-4 cursor-pointer" onClick={() => update("no_idea", !profile.no_idea)}>
            <Checkbox checked={profile.no_idea || false} />
            <Label className="cursor-pointer font-medium">I don't have an idea yet</Label>
          </div>
          {profile.no_idea ? (
            <div className="space-y-3">
              <h3 className="font-semibold">Finding Your Market Opportunity</h3>
              {["Identify your expertise area", "Map unmet needs - talk to clinicians", "Validate market size", "Analyze competition", "Assess feasibility", "Find your unique angle"].map((s, i) => (
                <div key={i} className="p-3 border rounded bg-white">
                  <span className="text-amber-600 font-medium">{i+1}.</span> {s}
                </div>
              ))}
            </div>
          ) : (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div><Label>Therapeutic Area</Label><Input value={profile.therapeutic_area || ""} onChange={e => update("therapeutic_area", e.target.value)} placeholder="e.g., Oncology" /></div>
                <div><Label>Target Indication</Label><Input value={profile.target_indication || ""} onChange={e => update("target_indication", e.target.value)} placeholder="e.g., NSCLC" /></div>
              </div>
              <div><Label>Market Opportunity</Label><Textarea value={profile.market_opportunity || ""} onChange={e => update("market_opportunity", e.target.value)} rows={2} placeholder="What's the gap?" /></div>
              <div><Label>Unmet Need</Label><Textarea value={profile.unmet_need || ""} onChange={e => update("unmet_need", e.target.value)} rows={2} /></div>
              <div><Label>Validation Done</Label><Textarea value={profile.validation_done || ""} onChange={e => update("validation_done", e.target.value)} rows={2} /></div>
              <div><Label>Competition</Label><Textarea value={profile.competitive_landscape || ""} onChange={e => update("competitive_landscape", e.target.value)} rows={2} /></div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
